import React from 'react';
import i18n from 'i18next'; import './styles.scss';

const NoTip = () => (
    <div className='coaching-tip-container'>
        <p className='no-tip-content'>{i18n.t('engagement.there_was_no_tip_for_you_this_time')}</p>
    </div>
);

export default NoTip;
